import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {FormGroup,FormControl,Validators,FormArray,FormBuilder} from '@angular/forms';
import { Context } from '../../model/context';
import { EmailNoteService } from '../../services/emailnote/emailnote-services';
import { StandardUIService } from '../../services/standardui-service/standardui-service';

@Component({
  selector: 'app-incident',
  templateUrl: './incident.component.html',
  styleUrls: ['./incident.component.scss']
})
export class IncidentComponent implements OnInit {

  constructor(private standardUIService: StandardUIService,private formBuilder: FormBuilder,private emailNoteService:EmailNoteService) { }
  @Input() componentContext;
  @Output() componentSelection = new EventEmitter<any>(); 
  @Input() context;
  @ViewChild('incidentsMessages') public incidentsMessages;
  EmailForm:FormGroup;
  emailNotes:any;
  emailNotesDataloaded:boolean = false;
  ngOnInit() {
    this.standardUIService.setIncidentEmailOrNote({"type":'',"open":false,item:''});
    this.EmailForm = this.formBuilder.group({      
      message: ['']
    });
    console.log(this.context);
    this.getIncidentNotes();
    // this.standardUIService.castIncident.subscribe((val:any)=>{  
    //   if(val && val.hasOwnProperty('saved')){
    //     this.getIncidentNotes();
    //     this.standardUIService.setIncidentEmailOrNote({"type":'',"open":false,item:''});
    //   }

    // })
  }
  getIncidentNotes(){
    if(this.context.id > 0){
      this.emailNoteService.getIncidentNotes(this.context.entityName,this.context.id).subscribe((result:any)=>{
        console.log(result);
        this.emailNotes = result;
        this.emailNotesDataloaded = true;
      })
    }
  }
  onSubmit(){
     console.log(this.EmailForm.value);
  }
}
